var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6668 9.24967C24.6668 6.34209 24.6668 4.88984 23.7634 3.98642C22.86 3.08301 21.4077 3.08301 18.5002 3.08301C15.5926 3.08301 14.1403 3.08301 13.2369 3.98642C12.3335 4.88984 12.3335 6.34209 12.3335 9.24967M3.0835 21.583C3.0835 15.7694 3.0835 12.8618 4.89033 11.0565C6.69716 9.25122 9.6032 9.24967 15.4168 9.24967H21.5835C27.3971 9.24967 30.3047 9.24967 32.11 11.0565C33.9153 12.8633 33.9168 15.7694 33.9168 21.583C33.9168 27.3966 33.9168 30.3042 32.11 32.1095C30.3032 33.9148 27.3971 33.9163 21.5835 33.9163H15.4168C9.6032 33.9163 6.69562 33.9163 4.89033 32.1095C3.08504 30.3027 3.0835 27.3966 3.0835 21.583Z",
    stroke: "#FFA808",
    strokeWidth: 2.3125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5003 26.7211C20.2039 26.7211 21.5837 25.571 21.5837 24.1526C21.5837 22.7343 20.2039 21.5827 18.5003 21.5827C16.7968 21.5827 15.417 20.4326 15.417 19.0127C15.417 17.5944 16.7968 16.4443 18.5003 16.4443M18.5003 26.7211C16.7968 26.7211 15.417 25.571 15.417 24.1526M18.5003 26.7211V27.7493M18.5003 16.4443V15.416M18.5003 16.4443C20.2039 16.4443 21.5837 17.5944 21.5837 19.0127",
    stroke: "#FFA808",
    strokeWidth: 2.3125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.7e2ff56f6cd64d382ecc2481d3419c27.svg";
export { ForwardRef as ReactComponent };